import { render, staticRenderFns } from "./AcademicCalender.vue?vue&type=template&id=4ec412a1&"
import script from "./AcademicCalender.vue?vue&type=script&lang=js&"
export * from "./AcademicCalender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports